import { Appointment } from "./interfaces";

export enum AppointmentAnalyticsEvent {
    BOOKED = "appointment_booked",
    RESCHEDULED = "appointment_rescheduled",
    CANCELLED = "appointment_cancelled"
}

export enum AppointmentAnalyticsChannel {
    PATIENT_WEB = "patient_web",
    DOCTOR_WEB = "doctor_web",
    WHATSAPP = "whatsapp"
}

export interface IAppointmentAnalyticsParams {
    appointment: Appointment;
    action: AppointmentAnalyticsEvent;
    channel: AppointmentAnalyticsChannel;
}

export enum QRScanEvent {
    SCAN_TO_WHATSAPP = "qr_scan_to_whatsapp",
    SCAN_TO_WEB = "qr_scan_to_web"
}

export interface IQRScanAnalyticsParams {
    doctorId: string;
    event: QRScanEvent;
}
